/*
 * console.log sink for local/browser logs
 */

import * as ConsoleLog from './console-log'
import { ILogEntry, ILogSink, ISinkContext, LogLevel } from './interfaces'

const getMessageColor = (logLevel: LogLevel) => {
  switch (logLevel) {
    case LogLevel.Info:
      return ConsoleLog.infoColor
    case LogLevel.Warning:
      return ConsoleLog.warningColor
    case LogLevel.Error:
      return ConsoleLog.errorColor
    default:
      ConsoleLog.error('Unknown LogLevel: ', logLevel)
  }

  return ConsoleLog.traceColor
}

export class ConsoleLogSink implements ILogSink {
  public name = () => 'ConsoleLogSink'

  public beginEvent = (): null => null

  public isLocal = () => true

  public endEvent = (logEntry: ILogEntry, context: ISinkContext) => {
    ConsoleLog.debug(
      !context,
      'Expected context to be null for sink',
      this.name()
    )
    this.writeEntry(logEntry)
  }

  public writeEntry = (logEntry: ILogEntry) => {
    if (logEntry.messageData) {
      const color = getMessageColor(logEntry.messageData.logLevel)
      const messageData = logEntry.messageData
      ConsoleLog.colorWrite(
        color,
        `Log.${LogLevel[logEntry.messageData.logLevel]}`,
        `0x${messageData.eventTagId.toString(16)}`,
        messageData.message,
        messageData.messageDetails
      )
    }

    if (logEntry.eventActionData) {
      ConsoleLog.event(
        `Log.Event:${logEntry.eventActionData.eventActionType}`,
        { tagId: `0x${logEntry.eventActionData.eventTagId.toString(16)}` },
        logEntry.eventActionData,
        logEntry.customData
      )
    }
  }
}
